module.exports = __webpack_public_path__ + "img/nullFile.9f499f63.svg";